"use client";
import { useCallback } from "react";
import {
  DropdownMenuLabel,
  DropdownMenuSeparator
} from "@/components/ui/dropdown-menu";
import { PopoverContent } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import SearchItem from "./SearchItem";
import { useRouter } from "next/navigation";
import { Skeleton } from "@/components/ui/skeleton";

const CurrencyContainer = ({
    data,
    search,
    loading,
    handleChangeText,
    onOpenChange,
}) => {

  const router = useRouter();
  
  const goToCatalog = useCallback(() => {
    router.push(`/jewellery?q=${search}`)
    onOpenChange(false);
  }, [  router, search, onOpenChange ]);

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) goToCatalog();
  };

  return (
    <PopoverContent
      className="
          w-[70vw] md:w-[40vw] max-h-[90vh]
          p-0 z-50 px-3 py-2 mr-1
          mt-1 md:mt-4 fixed right-0
          overflow-y-scroll vertical-scrollbar 
        "
        id="searchBar"
    >

      <DropdownMenuLabel
        className="
            text-center flex gap-7 p-0
            items-center justify-evenly	h-[35px]
          "
      >
        <div 
          className="
            flex flex-1 mt-2 text-sm 
            md:text-base
          "
        >
          <input
            className="
                p-2 border-[0.7px] border-[#bdbdbd] 
                text-font-primaryMuted h-[35px] 
                w-full hover:outline-none rounded-l-md
                border-r-0 focus:outline-none
                placeholder:italic placeholder:text-slate-400
                placeholder:text-sm placeholder:tracking-wide 
              "
            placeholder="Search Here"
            type="text"
            value={search}
            onChange={handleChangeText}
            onKeyDown={handleKeyDown}
          />
          <Button 
              className="
                  h-[35px] rounded-none py-0 px-2
                  bg-[#45d4d5] rounded-r-md
                  border-[0.7px] border-[#bdbdbd] 
                  border-l-0
              "
              variant="primary"
              onClick={goToCatalog}
          >
            <span>Search</span>  
          </Button>
        </div>
      </DropdownMenuLabel>

      {
        loading &&
        <div className="my-3">
          <Skeleton className="h-[25px] w-full drop-shadow-sm mb-1 rounded-none" />
          <DropdownMenuSeparator />
          <Skeleton className="h-[25px] w-full drop-shadow-sm mb-1 rounded-none" />
          <DropdownMenuSeparator />
          <Skeleton className="h-[25px] w-full drop-shadow-sm mb-1 rounded-none" />
          <DropdownMenuSeparator />
        </div>
      }

      <ul className="pt-4">
        {
          data.map((ele, i) => (
            <SearchItem 
              data={ele}
              onOpenChange={onOpenChange} 
              key={`search_item_${ele.title}_${i}`} 
            />
          ))
        }
      </ul>
    </PopoverContent>
  );
};

export default CurrencyContainer;
